import React, { FunctionComponent, useMemo } from 'react';
import TransferModal from './TransferModal';
import { useTransfer } from '../../../gqlCustomise/hooks/stockLite/useTransfer';
export interface ITransferModalContainerProps {
  loading: boolean;
  isModalOpen: boolean;
  carImageUrl: string;
  currentModel: string;
  toggleModal: () => void;
  handleSelect?: (code: string) => void;
  onAcceptTransfer: () => void;
  onDeclineTransfer: () => void;
}
const TransferModalContainer: FunctionComponent<ITransferModalContainerProps> = ({
  loading,
  isModalOpen,
  carImageUrl,
  currentModel,
  toggleModal,
  onAcceptTransfer,
  onDeclineTransfer,
}) => {
  const { validGroup, invalidGroup } = useTransfer();

  const onlyInvalidOptions = useMemo(
    () => invalidGroup?.transferOptions.length && !validGroup?.transferOptions.length,
    [invalidGroup, validGroup],
  );

  if (!isModalOpen && !carImageUrl) {
    return null;
  }

  return (
    <TransferModal
      loading={loading}
      currentModel={currentModel}
      isOpen={isModalOpen}
      carSourceImage={carImageUrl}
      onClose={toggleModal}
      onDeclineTransfer={onDeclineTransfer}
      onAcceptTransfer={onAcceptTransfer}
      transferGroups={[validGroup, invalidGroup]}
      onlyInvalidOptions={!!onlyInvalidOptions}
    />
  );
};

export default TransferModalContainer;
